export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-export-doc-cc1b04babf954ad8219e495983c5fde5.svg";